export const static_pages_Constants = {
    STATIC_PAGES_REQUEST: 'STATIC_PAGES__REQUEST',
    STATIC_PAGES_SUCCESS: 'STATIC_PAGES__SUCCESS',
    STATIC_PAGES_FAILURE: 'STATIC_PAGES__FAILURE',
    STATIC_PAGES_RESET: 'STATIC_PAGES_RESET',


    SET_SLUG: 'SET_SLUG'
};